export const getProductPerCategoryFilter = (categoryId) => {

  return ` and masterData(current(categories(id = "${categoryId}")))`;

};
